/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.generator

import io.kvision.redux.RAction
import pl.finn.forms.model.Attachment
import pl.finn.forms.model.FormStructureModel
import pl.finn.forms.model.DocumentTreeNode
import pl.finn.forms.model.PostCodeList

enum class FormView {
  EMPTY_FORM,
  NEW_FORM,
  EDIT_FORM
}

data class FormStructure(
  val view: FormView,
  val elements: DocumentTreeNode? = null,
  val model: Map<String, String?>? = null,
  val token: String? = null,
  val attachments: List<Attachment>? = null,
  val bladZapisu: String? = null
)

sealed class FormReduxAction : RAction {
  data class NewForm(val formData: FormStructureModel) : FormReduxAction()
  data class EditForm(val formData: FormStructureModel) : FormReduxAction()
  data class RefreshForm(val formData: FormStructure) : FormReduxAction()
  data class AddAttachment(val attachment: Attachment, val currentForm: DocumentTreeNode?) : FormReduxAction()
  data class RemoveAttachment(val name: String, val currentForm: DocumentTreeNode?) : FormReduxAction()
  data class SaveError(val saveError: String, val currentForm: DocumentTreeNode) : FormReduxAction()
}

fun formReducer(state: FormStructure, action: FormReduxAction): FormStructure = when (action) {
  is FormReduxAction.NewForm -> {
    FormStructure(
      FormView.NEW_FORM,
      action.formData.elementsList,
      action.formData.apiRequest,
      action.formData.token,
      bladZapisu = null
    )
  }
  is FormReduxAction.EditForm -> {
    FormStructure(
      FormView.EDIT_FORM,
      action.formData.elementsList,
      action.formData.apiRequest,
      action.formData.token,
      action.formData.attachments,
      bladZapisu = null
    )
  }
  is FormReduxAction.RefreshForm -> {
    FormStructure(
      FormView.EDIT_FORM,
      action.formData.elements,
      action.formData.model,
      action.formData.token,
      action.formData.attachments,
      bladZapisu = null
    )
  }
  is FormReduxAction.AddAttachment -> {
    val newAttachments = state.attachments?.plus(action.attachment) ?: listOf(action.attachment)
    state.copy(attachments = newAttachments, elements = action.currentForm)
  }
  is FormReduxAction.RemoveAttachment -> {
    val newAttachments = state.attachments?.filter { it.name != action.name }
    state.copy(attachments = newAttachments, elements = action.currentForm)
  }
  is FormReduxAction.SaveError -> {
    state.copy(bladZapisu = action.saveError, elements = action.currentForm)
  }
}
